import {
  collection,
  getDocs,
  limit,
  query,
  where,
} from "@firebase/firestore";
import { db } from "../../firebase-config";

const fetchUserDetails = async (bookingRef, propertyId, user) => {
  try {
    const userBookingsQuery = query(
      collection(db, "bookings"),
      where("id", "==", bookingRef),
      where("uid", "==", user.uid),
      limit(1)
    );
    const userBookings = await getDocs(userBookingsQuery);

    if (userBookings.empty) return null;

    const bookingData = userBookings.docs[0].data();

    const propertyDetailsQuery = query(
      collection(db, "properties"),
      where("id", "==", parseInt(propertyId, 10))
    );
    const propertyDetailsSnapshot = await getDocs(propertyDetailsQuery);

    const propertyData = !propertyDetailsSnapshot.empty
      ? propertyDetailsSnapshot.docs[0].data()
      : null;

    const userQuery = query(
      collection(db, "users"),
      where("uid", "==", user.uid)
    );
    const userSnapshot = await getDocs(userQuery);

    const userData = !userSnapshot.empty ? userSnapshot.docs[0].data() : null;

    return {
      startDate: bookingData.startDate,
      endDate: bookingData.endDate,
      bookingRef: bookingData.id,
      propertyName: propertyData?.name,
      name: userData?.name,
      email: user.email,
      phoneNumber: userData?.phonenumber,
      cost: bookingData?.cost,
      guests: bookingData?.guests
    };
  } catch (error) {
    console.error("Error fetching user bookings:", error);
    return null;
  }
};

export default fetchUserDetails;